import React from 'react'

import { useTranslation } from 'react-i18next'

import { useFilterConditionContext } from './useFilterCondition'
import { AvailableEntity } from '../types'
import { FieldLabel } from '@/Atomic/Atoms/FieldLabel'
import { Icon } from '@/Atomic/Atoms/Icon'
import { BasicSelect } from '@/Atomic/Atoms/Inputs/BasicSelect'

/**
 * FilterEntitySelector - Handles entity selection
 * Displays a dropdown to select which entity to filter on
 */
export const FilterEntitySelector: React.FC = () => {
  const { t } = useTranslation()
  const {
    condition,
    conditionEntity,
    isFirstRow,
    availableEntities,
    handleEntityChange,
  } = useFilterConditionContext()

  return (
    <div className="form-field entity-selector">
      {isFirstRow && (
        <FieldLabel
          name={`entity-${condition.id}`}
          label={t('filter.entity')}
        />
      )}
      <BasicSelect
        name={`entity-${condition.id}`}
        placeholder={t('filter.entity')}
        options={availableEntities}
        value={availableEntities.find(
          (opt) =>
            opt.value === conditionEntity &&
            opt.referenceField === condition.referenceField,
        )}
        onChange={(option) => {
          const selectedOption = option as {
            value: string
            referenceField?: string
          } | null
          handleEntityChange(
            selectedOption?.value ?? availableEntities[0]?.value ?? 'person',
            selectedOption?.referenceField,
          )
        }}
        getOptionValue={(option) => {
          const entity = option as AvailableEntity
          // Create unique key combining entity and reference field
          return entity.referenceField
            ? `${entity.value}__${entity.referenceField}`
            : entity.value
        }}
        formatOptionLabel={(option) => {
          const { relationType, label } = option as AvailableEntity
          const relationIcon =
            relationType === 'many-to-one'
              ? 'link'
              : relationType === 'one-to-many' ||
                  relationType === 'many-to-many'
                ? 'list'
                : undefined

          return (
            <div
              style={{
                display: 'flex',
                alignItems: 'center',
                gap: '8px',
              }}
            >
              {relationIcon && <Icon icon={relationIcon} size="sm" />}
              <span>{label}</span>
            </div>
          )
        }}
        isClearable={false}
        isSearchable={false}
      />
    </div>
  )
}
